import React, { useState, useEffect, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Popper from '@material-ui/core/Popper'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    padding: '0px',
  },
  searchBox: {
    padding: '0px', 
    margin: '0px',
  },
  searchResults: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 5,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    maxHeight: '300px',
    minWidth: '200px',
    maxWidth: '400px',
    overflowY: 'auto',
    marginTop: theme.spacing(1),
  },
  clearResults: {
    textAlign: 'right',
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  resultContainer: {
    border: '1px dotted #ccc',
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#e5e5e5',
    }
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: theme.spacing(0.5),
  },
  resultTitle: {
    fontWeight: 'bold',    
    flexGrow: 1,
  },
  resultCaption: {
    fontSize: '0.8em',
    color: theme.palette.grey[500],
    flexGrow: 0,
  },
  resultUrl: {
    color: 'blue',
    fontSize: '0.9em',
  },
  resultSnippet: {
    fontSize: '0.9em',
    color: '#999',
    '& em': {
      fontWeight: 'bold',
    }
  },
  disabledMessage: {
    padding: theme.spacing(1),
    color: '#999',
  }
}))

const ElasticSearchBox = ({
  results,
  loading,
  extractTitle = (record) => record.title,
  extractCaption = (record) => '',
  onSearch,
  onChoose,
  onReset,
}) => {

  const classes = useStyles()
  const delayTimeout = useRef(null)
  const anchorEl = useRef(null)
  const [value, setValue] = useState('')

  useEffect(() => {
    if(delayTimeout.current) clearTimeout(delayTimeout.current)
    delayTimeout.current = setTimeout(() => {
      onSearch(value)
    }, 500)
  }, [
    value,
  ])

  const open = value ? true : false

  return (
    <div className={ classes.root }>
      <TextField
        className={ classes.searchBox }
        label="Search"
        variant="outlined"
        fullWidth
        margin="dense"
        value={ value }
        onChange={ (e) => setValue(e.target.value) }
        ref={ anchorEl }
      />
      {
        open && (
          <Popper
            id="search-results-popper"
            open={ open }
            anchorEl={ anchorEl.current }
            placement="bottom-start"
            modifiers={{
              flip: {
                enabled: true,
              },
            }}
            className="zIndex2000"
          >
            <div className={ classes.searchResults }>
              
              <div>
                <div
                  className={ classes.clearResults }
                  onClick={ () => {
                    setValue('')
                    onReset()
                  }}
                >
                  Clear X
                </div>
                {
                  results.length <= 0 && (
                    <div
                      className={ classes.disabledMessage }
                    >
                      {
                        loading ? 'Loading...' : 'No results found...'
                      }
                    </div>
                  )
                }
                {
                  results
                    .map((result, i) => {               
                      return (
                        <div
                          key={ i }
                          className={ classes.resultContainer }
                          onClick={ () => {
                            setValue('')
                            onReset()
                            onChoose(result)
                          }}
                        >
                          <div className={ classes.titleContainer }>
                            <div className={ classes.resultTitle }>
                              { extractTitle(result.data) }
                            </div>
                            <div className={ classes.resultCaption }>
                              { extractCaption(result.data) }
                            </div>
                          </div>
                          {
                            result.highlight.content && (
                              <div
                                className={ classes.resultSnippet }
                                dangerouslySetInnerHTML={{__html: result.highlight.content.join(', ') }}
                              >
                              </div>
                            )
                          }
                        </div>
                      )
                    })
                }
              </div>
            </div>
          </Popper>
        )
      }
    </div>
  )
}

export default ElasticSearchBox